import {
  locations,
  experiences,
  postings,
  sortBy,
  HIRIST_FUNCTIONAL_AREAS,
  categories,
} from '@jobseeker/lotus/components/JobSearchBar/data';

export const optionsMap: any = {
  category: categories,
  experience: experiences,
  posting: postings,
  loc: locations,
  sort: sortBy,
  functionalArea: HIRIST_FUNCTIONAL_AREAS,
};

export const calculateAppliedFilters = (formValue: any, extendOptions = {}) => {
  let filterObj: any[] = [];
  const extendedOptionMap = {...optionsMap, ...extendOptions};
  for (const key of Object.keys(formValue)) {
    if (formValue[key]) {
      if (Array.isArray(formValue[key]) && formValue[key].length) {
        const options =
          key == 'posting' && formValue[key].includes(0)
            ? null
            : extendedOptionMap[key];
        if (!options) {
          continue;
          // return [];
        }
        let filteredOptions = formValue[key];
        options.forEach((option: any) => {
          if (
            option.selected?.length &&
            filteredOptions.includes(option.value)
          ) {
            filteredOptions = filteredOptions.filter(
              (o: any) => !option.selected.includes(o)
            );
          }
        });
        filteredOptions = filteredOptions.map((option: any) => ({
          ...options.find((o: any) => o.value === option),
          key,
        }));
        filterObj = filterObj.concat(filteredOptions);
      } else {
        const options = extendedOptionMap[key];
        if (!options) {
          continue;
          // return [];
        }
        filterObj = filterObj.concat(
          options.filter((o: any) => o.value == formValue[key])
        );
      }
    }
  }
  return filterObj;
};
